/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import Api from "../../../../services/ServiceApi";
import { Collapse } from "antd";

const { Panel } = Collapse;

export default function NodeSiteDetail({ title, data }) {
  return (
    <>
      <Collapse
        className="container"
        expandIconPosition="right"
        defaultActiveKey={["1"]}
      >
        <Panel
          header={
            <>
              <img
                src={Api.absoluteUrl(`/icon/bbtec/body/original-station.svg`)}
                alt={title ? title : null}
                title={title ? title : null}
              />
              <h4>{title ? title : null}</h4>
            </>
          }
          key="1"
        >
          <div className="row">
            <span className="col col-4 content-label">{`Node Code`}</span>
            <span className="col col-8 content-text">{data.job_node_code}</span>
          </div>
          <div className="row">
            <span className="col col-4 content-label">{`Node Name`}</span>
            <span className="col col-8 content-text">{data.job_node_name}</span>
          </div>
        </Panel>
      </Collapse>
    </>
  );
}
